import { useSyncExternalStore } from "react";

export type Theme = "light" | "dark" | "system";
const key = "tedalytics.theme";
const media = window.matchMedia("(prefers-color-scheme: dark)");
const listeners = new Set<() => void>();
const valid = (value: unknown): value is Theme =>
  ["light", "dark", "system"].includes(String(value));
let preference: Theme = "system";
try {
  const saved = localStorage.getItem(key);
  if (valid(saved)) preference = saved;
} catch {
  /* A blocked storage area should not prevent rendering. */
}
let snapshot = { preference, resolved: media.matches ? "dark" : "light" };
function apply() {
  const resolved =
    preference === "system" ? (media.matches ? "dark" : "light") : preference;
  document.documentElement.dataset.theme = resolved;
  snapshot = { preference, resolved };
  listeners.forEach((listener) => listener());
}
export function setTheme(value: Theme) {
  preference = value;
  try {
    localStorage.setItem(key, value);
  } catch {
    /* Use the choice for this session. */
  }
  apply();
}
media.addEventListener("change", apply);
window.addEventListener("storage", (event) => {
  if (event.key === key) {
    preference = valid(event.newValue) ? event.newValue : "system";
    apply();
  }
});
apply();
const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
export const useTheme = () => useSyncExternalStore(subscribe, () => snapshot);
